// extracted by mini-css-extract-plugin
export default {"addResources":"AddResources_addResources__-IYyN","warning":"AddResources_warning__4gcDy","title":"AddResources_title__lrnq7","roomIcon":"AddResources_roomIcon__F4XYQ"};